import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const AssetCardRoot = styled.div`
  display: flex;
`;

export const Logotype = styled.div`
  margin-right: 8px;
`;

export const Title = styled.h1`
  ${typographyV2.titleLg};
  color: var(--text-default);
`;

export const Subtitle = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  text-transform: uppercase;
`;
